// import vendorServicing_order_details from "./vendorServicing_order_details";
import { getImageUrl,getVendorBusinessImageUrl } from "../helpers/mediaUrl";

var deviceTypeCustSerOrdersPage;

//VenderServicing_order_details variables
var Ord_id = "";
var orderFlow = "";
var orderStatus = "";
var lat;
var lon;
var deliveryType = "";
var comissionAmt = "";
var orderDetailsjs = "";


export default class vendorServicing_orders {
  constructor() {
    this.noActiveOrder = $("#noActiveOrder");
    this.PastOrdersHeader = $("#PastOrdersHeader");
    this.CurrentOrdersHeader = $("#CurrentOrdersHeader");

    //checking the size of the screen
    var screenWidthOrders = $(window).width();

    if (screenWidthOrders < 768) {
      //show mobile view

      deviceTypeCustSerOrdersPage = "mobile";
      $("#MobilePastOrder").removeClass("d-none");
    } else {
      deviceTypeCustSerOrdersPage = "desktop";
      $("#vendorDesktopPastOrder").removeClass("d-none");
    }
    this.bindEvents();
  }

  bindEvents = () => {
    this.loadCurrentOredrs(0);
    this.loadPastOredrs(0);
    this.getOrdersCount();
  };

  setCookieOrderID = (e) => {
    var Order_ID = e.target.value;

    $.ajax({
      type: "POST",
      url: baseURL + "api/vendor/setVendorOrderID",
      headers: { Authorization: X_API_KEY },
      data: {
        Order_ID: Order_ID,
      },
      success: console.log("Order_ID cookie is set"),
    });
    this.VenderServicing_order_details_constructor(Order_ID);
  };

  getOrdersCount = () => {
    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/ordersCount",
      headers: { Authorization: X_API_KEY },
      success: this.showOrdersPagination,
    });
  };

  loadCurrentOredrs = (offsetCount) => {
    //To Get Current Orders

    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/orders",

      data: {
        Type: "current",
        Offset: offsetCount,
      },

      headers: { Authorization: X_API_KEY },

      success: this.showCurrentOredrs,
    });
  };

  // To Show Current Orders on ui
  showCurrentOredrs = (res) => {
    $("#DesktopCurrentOrder").empty();

    if (res.length == 0) {
      this.CurrentOrdersHeader.addClass("d-none");
      this.PastOrdersHeader.addClass("d-none");
      this.noActiveOrder.removeClass("d-none");
    } else {
      this.CurrentOrdersHeader.removeClass("d-none");
      this.PastOrdersHeader.removeClass("d-none");
      this.noActiveOrder.addClass("d-none");

      res.forEach((element) => {
        const orderImage = getImageUrl(element?.Customer?.Image_URL);
        //Old code
        // var nextOrder = `<div class="card">
        //                       <div class="card-body">
        //                           <div class="row">
        //                               <div class="col">
        //                                   <p class="card-title">${element.Customer.Customer_Name}</p>
        //                                   <p class="card-title">Enquiry Received : ${element.Order.Order_booked_date_time}</p>
        //                                   <h6 class="card-text">${element.Order.Order_Status}</h6>
        //                               </div>
        //                               <div class="col d-flex justify-content-end">
        //                                   <p class="card-title">Rs ${element.Order.Final_Bill_Amount}</p>
        //                                   <a href="Vendor_servicing_order_details?Ord_id=${element.Order.Order_ID}">&nbsp;&nbsp;<button type="button" class="btn btn-outline-warning btn-sm">View Details</button></a>
        //                               </div>
        //                           </div>
        //                       </div>
        //                   </div>`;
        // $("#CurrentOrdersBox").append(nextOrder);
        //new code
        if (deviceTypeCustSerOrdersPage == "desktop") {
          var item = `<div class="card mb-2 border border-3 ml-4 mr-1">
        <div class="card-body">
            <div class="row">
                <div class="col-2 col-lg-2 col-xl-1">
                <img src="${orderImage}" width="100%" class="rounded-3" onerror="this.onerror=null;this.src='${baseURL}assets/default.png';">
                </div>
                <div class="col-7"">

                    <h4 class="mb-1">${element.Customer.Customer_Name}</h4>
                    <p class="mb-0"></p>
                    <p class="display-6 mb-0" style="color: gray;">ORDER #${element.Order.Order_No} | ${element.Order.Order_booked_date_time}</p>
                    <!-- <button type="button" class="btn" style="color: #ff385c;" value="${element.Order.Order_ID}">VIEW DETAILS</button> -->
                    <button class="btn view-order-details-button viewOrderBtn" type="button" style="color: #ff385c; margin-left:-1rem;"  value="${element.Order.Order_ID}">VIEW DETAILS</button>
                </div>

                <div class="col">
                    <p class="d-flex justify-content-end display-6">${element.Order.Order_Status} </p>
                </div>
            </div>
            <hr>
            <div class="row">

                <div class="col-3">
                    <p class="d-flex justify-content-end">Total Amount: ${element.Order.Final_Bill_Amount}
                      
                    </p>
                </div>
            </div>

        </div>
     </div>`;

          $("#DesktopCurrentOrder").append(item);
        } else {
          //mobile view for top products
          var item = `<div class="card ml-3 border border-3 mb-1">
                      <div class="card-body ">
                              <div class="row">
                                  <h4 class=" truncate2">${element.Customer.Customer_Name}</h4>
                                  <p class="mb-1"></p>
                                  <p class="m-0">Total Amount: Rs. ${element.Order.Final_Bill_Amount} <label><button class="btn border-0 view-order-details-button viewOrderBtn" type="button" value="${element.Order.Order_ID}"></button><img src="https://img.icons8.com/ios-filled/16/null/forward--v1.png" /></label></p>
                              </div>
                          <hr>
                          <div class="row ">
                              <div class="col-7">
                                  <p class="card-text truncate" style="font-size:0.8rem;"><b>${element.Order.Order_Status}</b></p>
                              </div>

                              <div class="col-5">
                                  <p class="d-flex justify-content-end m-0" style="font-size:0.8rem;">Total Amount: ${element.Order.Final_Bill_Amount}</p>
                              </div>
                          </div>
                      </div>
                    </div>`;

          $("#DesktopCurrentOrder").append(item);
          $("#vendorDesktopPastOrder").removeClass("d-none");
        }
        //   const docFileInput = document.getElementById(element.Document_ID);
        //   docFileInput.addEventListener("change", this.isDocumentImmage);
        //   eachDocImageValid[element.Document_ID] = false;
        //   documentIdArray.push([element.Document_ID]);
      });
      $(".viewOrderBtn").on("click", this.setCookieOrderID);
    }
  };

  loadPastOredrs = (offsetCount) => {
    //To Get Current Orders

    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/orders",

      data: {
        Type: "past",
        Offset: offsetCount,
      },

      headers: { Authorization: X_API_KEY },

      success: this.showPastOredrs,
    });
  };

  // To Show Past Orders on ui
  showPastOredrs = (res) => {
    $("#vendorDesktopPastOrder").empty();

    res.forEach((element) => {
      const orderImage = getImageUrl(element?.Customer?.Image_URL);
      //   const docFileInput = document.getElementById(element.Document_ID);
      //   docFileInput.addEventListener("change", this.isDocumentImmage);
      //   eachDocImageValid[element.Document_ID] = false;
      //   documentIdArray.push([element.Document_ID]);
      //new code
      if (deviceTypeCustSerOrdersPage == "desktop") {
        var item = `<div class="card mb-2 border border-3 ml-4 mr-1">
        <div class="card-body">
            <div class="row">
                <div class="col-2 col-lg-2 col-xl-1">
                <img src="${orderImage}" width="100%" class="rounded-3" onerror="this.onerror=null;this.src='${baseURL}assets/default.png';">
                </div>
                <div class="col-7"">

                    <h4 class="mb-1">${element.Customer.Customer_Name}</h4>
                    <p class="mb-0"></p>
                    <p class="display-6 mb-0" style="color: gray;">ORDER #${element.Order.Order_No} | ${element.Order.Order_booked_date_time}</p>
                    <!-- <button type="button" class="btn" style="color: #ff385c;" value="${element.Order.Order_ID}">VIEW DETAILS</button> -->
                    <button class="btn view-order-details-button viewOrderBtnforPast" type="button" style="color: #ff385c; margin-left:-1rem;"  value="${element.Order.Order_ID}">VIEW DETAILS</button>
                </div>

                <div class="col">
                    <p class="d-flex justify-content-end display-6">${element.Order.Order_Status} </p>
                </div>
            </div>
            <hr>
            <div class="row">

                <div class="col-3">
                    <p class="d-flex justify-content-end">Total Amount: ${element.Order.Final_Bill_Amount}
                      
                    </p>
                </div>
            </div>

        </div>
    </div>`;

        $("#vendorDesktopPastOrder").append(item);
      } else {
        var item = `<div class="card ml-3 border border-3 mb-1">
        <div class="card-body ">
        
                <div class="row">
                    <h4 class=" truncate2">${element.Customer.Customer_Name}</h4>
                    <p class="mb-1"></p>
                    <p class="m-0">Total Amount: Rs. ${element.Order.Final_Bill_Amount} <label><button class="btn border-0 view-order-details-button viewOrderBtnforPast" type="button" value="${element.Order.Order_ID}"></button><img src="https://img.icons8.com/ios-filled/16/null/forward--v1.png" /></label></p>  
                </div>
        
            <hr>
            <div class="row ">
        
                <div class="col-7">
                    <p class="card-text truncate" style="font-size:0.8rem;"><b>${element.Order.Order_Status}</b></p>
                </div>
        
                <div class="col-5">
                    <p class="d-flex justify-content-end m-0" style="font-size:0.8rem;">Total Amount: ${element.Order.Final_Bill_Amount}</p>
                </div>
            </div>
        
         
        
            <!-- </div> -->
        </div>
        </div>`;

        $("#vendorDesktopPastOrder").append(item);
      }
    });
    $(".viewOrderBtnforPast").on("click", this.setCookieOrderID);
  };

  // Pagiation for orders listing
  showOrdersPagination = (res) => {
    $("#CurrentOrdersPaginationBox").empty();
    $("#PastOrdersPaginationBox").empty();

    var currentOredrsCountTot = res.CurrentOrdersCount;
    var pastOredrsCountTot = res.PastOrdersCount;

    var currentPages = Math.ceil(currentOredrsCountTot / 10);
    var pastPages = Math.ceil(pastOredrsCountTot / 10);
    if (currentPages > 1) {
      var currentNumbers = ``;
      for (var i = 1; i <= currentPages; i++) {
        currentNumbers = `${currentNumbers}<li class="page-item CurrentOrdersPgNo" id="CurrentOrdersPgNo${i}" value=${
          i - 1
        }><a class="page-link" href="">${i}</a></li>`;

        //To exit if more then 5 pages exist
        if (i == 5) {
          break;
        }
      }
      var currentOrdersPageNo = `<nav aria-label="Current-orders-pagination">
                                  <ul class="pagination justify-content-center">
                                      <li class="page-item disabled d-none">
                                          <a class="page-link" href="" tabindex="-1" aria-disabled="true">Previous</a>
                                      </li>
                                      ${currentNumbers}
                                      <li class="page-item d-none">
                                          <a class="page-link" href="">Next</a>
                                      </li>
                                  </ul>
                              </nav>`;
      $("#CurrentOrdersPaginationBox").append(currentOrdersPageNo);
      //   const docFileInput = document.getElementById(element.Document_ID);
      $(".CurrentOrdersPgNo").on("click", this.loadOrderPage);
      //   eachDocImageValid[element.Document_ID] = false;
      //   documentIdArray.push([element.Document_ID]);
    }
    if (pastPages > 1) {
      var pastNumbers = ``;
      for (var i = 1; i <= pastPages; i++) {
        pastNumbers = `${pastNumbers}<li class="page-item PastOrdersPgNo" id="PastOrdersPgNo${i}" value=${
          i - 1
        }><a class="page-link" href="">${i}</a></li>`;

        //To exit if more then 5 pages exist
        if (i == 5) {
          break;
        }
      }
      var pastOrdersPageNo = `<nav aria-label="Current-orders-pagination">
                                  <ul class="pagination justify-content-center">
                                      <li class="page-item disabled d-none">
                                          <a class="page-link" href="" tabindex="-1" aria-disabled="true">Previous</a>
                                      </li>
                                      ${pastNumbers}
                                      <li class="page-item d-none">
                                          <a class="page-link" href="">Next</a>
                                      </li>
                                  </ul>
                              </nav>`;
      $("#PastOrdersPaginationBox").append(pastOrdersPageNo);
      //   const docFileInput = document.getElementById(element.Document_ID);
      $(".PastOrdersPgNo").on("click", this.loadOrderPage);
      //   eachDocImageValid[element.Document_ID] = false;
      //   documentIdArray.push([element.Document_ID]);
    }
  };

  loadOrderPage = (e) => {
    window.scrollTo(0, 0);
    e.preventDefault();

    var pageNumber = (e.target.innerText - 1) * 10;
    if (e.currentTarget.classList[1] == "CurrentOrdersPgNo") {
      this.loadCurrentOredrs(pageNumber);
    } else if (e.currentTarget.classList[1] == "PastOrdersPgNo") {
      this.loadPastOredrs(pageNumber);
    }
  };

  //VenderServicing_order_details functions

  VenderServicing_order_details_constructor = (Order_ID) => {
    this.orderDetailsBindEvents(Order_ID);
    if (orderDetalisMain == false) {
      $(".orderStatusSubmitBtn").on("click", this.submitStatusAction);
    }
    orderDetalisMain = true;
  };

  orderDetailsBindEvents = (Order_ID) => {
    orderDetailsjs = this;
    this.emailReceiptBtn = $(".emailReceiptBtn");
    this.copyCustomerLocationBtn = $(".copyCustomerLocationBtn");
    $(".currentlyActive").addClass("d-none");
    $(".vendororderdetails").addClass("currentlyActive");
    $(".vendororderdetails").removeClass("d-none");

    // this.emailReceiptBtn.on("click", this.sendEmailReceipt);
    // this.orderDetailsLoadCurrentOredrs(0);
    // this.orderDetailsLoadPastOredrs(0);
    // this.getOrderDetails();
    // running on https://www.example.com?name=n1&name=n2
    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);
    Ord_id = urlParams.get("Ord_id");

    this.getOrderDetails(Order_ID);
  };

  getOrderDetails = (Order_ID) => {
    // if (Ord_id == null) {
    //   return;
    // }
    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/order",
      headers: { Authorization: X_API_KEY },
      data: {
        Order_ID: Order_ID,
        // Offset: offsetCount,
      },
      // success: function (res) {
      //
      // },
      success: this.showCurrentOredrDetails,
    });
  };

  orderDetailsLoadCurrentOredrs = (offsetCount) => {
    //To Get Current Orders

    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/orders",

      data: {
        Type: "current",
        Offset: offsetCount,
      },

      headers: { Authorization: X_API_KEY },

      success: this.showCurrentOredrs,
    });
  };

  // To Show Current Orders on ui
  showCurrentOredrDetails = (res) => {
    $("#OrderDetailsBox").empty();

    //Sae Comission Amt
    comissionAmt = res.Commission;

    //Save Order_ID for email ajax
    Ord_id = res.Order.Order_ID;

    //Saving Flow type for Order status change button
    orderFlow = res.Order.Flow;
    orderStatus = res.Order.Order_Status;

    //Total amount by adding item price
    var items = "";
    var item_Total = 0;
    deliveryType = res.Order.Delivery_Details;

    //To show Delivery date and time for delivered orders
    var Delivery_date_time =
      res.Order.Order_Status == "ORDER DELIVERED"
        ? `<p class="card-text">${
            res.Order.Delivery_date_time == null
              ? "null"
              : res.Order.Delivery_date_time
          }</p>`
        : ``;

    //To show Resend OTP Button if Status in either i)ENQUIRY ACCEPTED, ii)ORDER OUT FOR DELIVERY or iii)ORDER READY
    if (
      res.Order.Order_Status == "ENQUIRY ACCEPTED" ||
      res.Order.Order_Status == "ORDER OUT FOR DELIVERY" ||
      res.Order.Order_Status == "ORDER READY"
    ) {
      var Resend_OTP_Btn = `<button type="button" id="ResendDelivOTPbtn" class="btn btn-secondary ResendDelivOTPbtnClass bg-orange" style="height: 40px;" value="${res.Order.Order_ID}" name="${res.Customer.Customer_Name}">Resend OTP</button>`;
    } else {
      var Resend_OTP_Btn = ``;
    }
    // res.Order.Order_Status == "ORDER DELIVERED" ? `<p class="card-text">${res.Order.Delivery_date_time == null? "null": res.Order.Delivery_date_time}</p>`: ``;

    //To show Delivery date and time for delivered orders
    var Customer_PhoneNo = this.ShowCustomerPhoneNo(res.Order.Order_Status);
    var Customer_PhoneNo_code = "";
    if (Customer_PhoneNo == true) {
      Customer_PhoneNo_code = ` <div class="card">
                                  <div class="card-body">
                                  <h6 class="card-title"><b>Customer Contact</b></h6>
                                    <div class="row">
                                      <div class="col-6">
                                        <div>
                                          <p class="card-text my-0">Name:&nbsp;  ${
                                            res.Customer == null
                                              ? "Not Found"
                                              : res.Customer.Customer_Name ==
                                                  null
                                                ? "Not Found"
                                                : res.Customer.Customer_Name
                                          }</p>
                                          <p class="card-text my-0">Phone Number:&nbsp;  ${
                                            res.Customer == null
                                              ? "Not Found"
                                              : res.Customer.Phone_Number ==
                                                  null
                                                ? "Not Found"
                                                : res.Customer.Phone_Number
                                          }</p>
                                          <p class="card-text">Email:&nbsp;  ${
                                            res.Customer == null
                                              ? "Not Found"
                                              : res.Customer.Email == null
                                                ? "Not Found"
                                                : res.Customer.Email
                                          }</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div> `;
    }

    //To show Email Receipt btn if order delivered
    var Email_btn = ``;
    ///////////////////UNCOMMENT THE CODE/////////////////////////
    // if (res.Order.Order_Status == "ORDER DELIVERED") {
    //   Email_btn = `   <div class="col d-flex justify-content-center">
    //                     <button type="button" class="btn btn-warning  text-uppercase bg-orange basicDetailsBtn emailReceiptBtn vendorButtons" data-bs-toggle="modal" data-bs-target="#emailreceiptmodal">Email Receipt</button>
    //                   </div>`;
    // }
    /////////////////////////////////////////////////////////////
    var bottomActionButtons = ``;
    if (this.ShowBottomActionButtonsFlag(res.Order.Order_Status) == true) {
      bottomActionButtons = ` <div class="card ">
                                <div class="row">
                                  <div class="col d-flex justify-content-center">
                                    <button type="button" class="btn btn-warning  text-uppercase bg-orange changeStatusBtn vendorButtons" data-bs-toggle="modal" href="#changestatus" role="button">Change Status</button>
                                  </div>
                                  <div class="col d-flex justify-content-center">
                                    <button type="button"  class="btn btn-warning  text-uppercase bg-orange copyCustomerLocationBtn vendorButtons" data-bs-toggle="modal" href="#copyCustomerLocationBtn" role="button">Open Customer Address</button>
                                  </div>
                                  ${Email_btn}
                                </div>
                              </div>`;
    } else if (
      this.ShowBottomActionButtonsFlag(res.Order.Order_Status) == "delivered"
    ) {
      bottomActionButtons = ` <div class="card ">
      <div class="row">
        <div class="col d-flex justify-content-center">
         <button type="button" class="btn btn-warning  text-uppercase bg-orange basicDetailsBtn emailReceiptBtn vendorButtons" data-bs-toggle="modal" data-bs-target="#emailreceiptmodal">Email Receipt</button>
        </div>
      </div>
    </div>`;
    }

    res.OrderProducts.forEach((element) => {
      items = `${items} <div class="row">
                                <div class="col">
                                    <p style="font-size:13px">${element.ProductName} X ${element.Quantity}</p>
                                </div>
                                <div class="col d-flex justify-content-end">
                                    <p style="font-size:13px">&#8377 ${element.Price}</p>
                                </div>
                            </div> `;
      item_Total = item_Total + parseInt(element.Price);
    });
    var currentOrderDetails = `
      <div class="card mb-2 mt-1" style="background: #ff385c !important;">
  
          <div class="card-body text-white">
          <p class="text-white">Order No:#${res.Order.Order_No}</p>
          <h6 class="text-white">${res.Order.Order_Status}, ${
            res.OrderProducts.length
          } item${res.OrderProducts.length > 1 ? "s" : ""}, Rs.${
            res.Order.Final_Bill_Amount
          }</h6>
  
          </div>
      </div>
      
      
      <div class="mt-2"></div>
  
      <div id="collapseCurrentOrders" class="collapse show" role="tabpanel" aria-labelledby="headingCurrentOrders">
  
  
        <div class="card">
            <div class="card-body">
                <h6 class="card-title"><b>${res.Vendor.Business_Name}</b></h6>
                <p  class="card-title">${res.Order.Vendor_Address_Details ? res.Order.Vendor_Address_Details : (res.VendorAddress.Address_Line_1 + (res.VendorAddress.Landmark ? ', ' + res.VendorAddress.Landmark : '') + ', ' + res.VendorAddress.City + ', ' + res.VendorAddress.State + ', ' + res.VendorAddress.Pincode)}</p>
                <h6 class="card-text"><b>${res.Customer.Customer_Name}</b></h6>
                <p class="card-title" id ="customerAddress">${res.Order.Customer_Address_Details}</p>
                
            </div>
        </div>
        ${Customer_PhoneNo_code}
        <div class="card">
          <div class="card-body">
            <div class="row">
                <div class="col-6">
                    <div>
                    <p class="card-text">Mode of Delivery: ${
                      (res.DeliveryOption && res.DeliveryOption.Delivery_Name)
                        ? res.DeliveryOption.Delivery_Name
                        : (res.Order.Delivery_Details ? res.Order.Delivery_Details : "Vendor Managed")
                    }</p>
                    </div>
                    <br>
                    ${Delivery_date_time}
                </div>
                <div class="col-6 d-flex justify-content-end align-self-center">
                ${Resend_OTP_Btn}
                </div>
            </div>
          </div>
        </div>
  
        <div class="card">
            <div class="card-body">
                <div class="row container pe-0">
                    <div class="col">
                        <h6 class="card-title"><b><u>Details</u></b></h6>
                        ${items}
            </div>
        </div>
  
        <div class="card">
            <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <p style="font-size:13px">Item Total</p>
                            </div>
                            <div class="col d-flex justify-content-end">
                                <p style="font-size:13px">&#8377 ${item_Total}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p style="font-size:13px">Coupon Disount</p>
                            </div>
                            <div class="col d-flex justify-content-end">
                                <p style="font-size:13px">&#8377 ${
                                  res.Order.Coupon_discount
                                }</p>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col">
                                <p style="font-size:13px">Packaging Charges</p>
                            </div>
                            <div class="col d-flex justify-content-end">
                                <p style="font-size:13px">&#8377 ${
                                  res.Order.Packaging_charges == null
                                    ? 0
                                    : res.Order.Packaging_charges
                                }</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p style="font-size:13px">GST</p>
                            </div>
                            <div class="col d-flex justify-content-end">
                                <p style="font-size:13px">&#8377 ${
                                  res.Order.GST
                                }  </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p style="font-size:13px">Delivery Charges</p>
                            </div>
                            <div class="col d-flex justify-content-end">
                                <p style="font-size:13px">&#8377 ${
                                  res.Order.Delivery_Charges
                                }</p>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <p class="card-title"><b></b></p>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <p class="card-title">TOTAL &#8377 ${
                              res.Order.Final_Bill_Amount
                            }</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        ${bottomActionButtons}
        &nbsp;`;
    $("#OrderDetailsBox").append(currentOrderDetails);

    //${res.PaymentDetails.Payment_Mode}

    //   const docFileInput = document.getElementById(element.Document_ID);
    //   docFileInput.addEventListener("change", this.isDocumentImmage);
    //   eachDocImageValid[element.Document_ID] = false;
    //   documentIdArray.push([element.Document_ID]);

    $(".emailReceiptBtn").on("click", this.sendEmailReceipt);
    $(".changeStatusBtn").on("click", this.loadStatusOptions(orderFlow));
    // $(".copyCustomerLocationBtn").on(
    //   "click",
    //   this.loadStatusOptions(orderFlow)
    // );

    lat = res.Order.Customer_Address_Lat;
    lon = res.Order.Customer_Address_Lon;
    $(".copyCustomerLocationBtn").on("click", this.goToLocation);

    // $(".orderStatusSubmitBtn").on("click", this.launchStatusMessageModal);
    $(".ResendDelivOTPbtnClass").on("click", this.resendDeliveryOTP);
  };

  orderDetailsLoadPastOredrs = (offsetCount) => {
    //To Get Current Orders

    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/orders",

      data: {
        Type: "past",
        Offset: offsetCount,
      },

      headers: { Authorization: X_API_KEY },

      success: this.orderDetailsShowPastOredrs,
    });
  };

  //To Copy Customer's Location
  goToLocation = () => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${lat},${lon}`,
    );
  };

  // To Show Past Orders on ui
  orderDetailsShowPastOredrs = (res) => {
    $("#PastOrdersBox").empty();

    res.forEach((element) => {
      var nextOrder = `<div class="card">
                                <div class="card-body">
                                    <div class="row">
    
                                        <div class="col">
                                            <p class="card-title">${element.Customer.Customer_Name}</p>
                                            <h6 class="card-text">${element.Order.Order_Status}</h6>
                                        </div>
                                        <div class="col d-flex justify-content-end">
                                            <p class="card-title">Rs ${element.Order.Final_Bill_Amount}</p>
                                            <a href="Vendor_servicing_order_details?Ord_id=${element.Order.Order_ID}"><img src="assets/dist/images/chevron-right.svg" width="15" height="15" alt="^"></a>
                                        </div>
                                    </div>
                                </div>
                            </div>`;
      $("#PastOrdersBox").append(nextOrder);
      //   const docFileInput = document.getElementById(element.Document_ID);
      //   docFileInput.addEventListener("change", this.isDocumentImmage);
      //   eachDocImageValid[element.Document_ID] = false;
      //   documentIdArray.push([element.Document_ID]);
    });
  };

  // Pagiation for orders listing
  orderDetailsShowOrdersPagination = (res) => {
    $("#CurrentOrdersPaginationBox").empty();
    $("#PastOrdersPaginationBox").empty();

    var currentOredrsCountTot = res.CurrentOrdersCount;
    var pastOredrsCountTot = res.PastOrdersCount;

    var currentPages = Math.ceil(currentOredrsCountTot / 10);
    var pastPages = Math.ceil(pastOredrsCountTot / 10);
    if (currentPages > 1) {
      var currentNumbers = ``;
      for (var i = 1; i <= currentPages; i++) {
        currentNumbers = `${currentNumbers}<li class="page-item CurrentOrdersPgNo" id="CurrentOrdersPgNo${i}" value=${
          i - 1
        }><a class="page-link" href="">${i}</a></li>`;

        //To exit if more then 5 pages exist
        if (i == 5) {
          break;
        }
      }
      var currentOrdersPageNo = `<nav aria-label="Current-orders-pagination">
                                  <ul class="pagination justify-content-center">
                                      <li class="page-item disabled d-none">
                                          <a class="page-link" href="" tabindex="-1" aria-disabled="true">Previous</a>
                                      </li>
                                      ${currentNumbers}
                                      <li class="page-item d-none">
                                          <a class="page-link" href="">Next</a>
                                      </li>
                                  </ul>
                              </nav>`;
      $("#CurrentOrdersPaginationBox").append(currentOrdersPageNo);
      //   const docFileInput = document.getElementById(element.Document_ID);
      $(".CurrentOrdersPgNo").on("click", this.orderDetailsLoadOrderPage);
      //   eachDocImageValid[element.Document_ID] = false;
      //   documentIdArray.push([element.Document_ID]);
    }
    if (pastPages > 1) {
      var pastNumbers = ``;
      for (var i = 1; i <= pastPages; i++) {
        pastNumbers = `${pastNumbers}<li class="page-item PastOrdersPgNo" id="PastOrdersPgNo${i}" value=${
          i - 1
        }><a class="page-link" href="">${i}</a></li>`;

        //To exit if more then 5 pages exist
        if (i == 5) {
          break;
        }
      }
      var pastOrdersPageNo = `<nav aria-label="Current-orders-pagination">
                                  <ul class="pagination justify-content-center">
                                      <li class="page-item disabled d-none">
                                          <a class="page-link" href="" tabindex="-1" aria-disabled="true">Previous</a>
                                      </li>
                                      ${pastNumbers}
                                      <li class="page-item d-none">
                                          <a class="page-link" href="">Next</a>
                                      </li>
                                  </ul>
                              </nav>`;
      $("#PastOrdersPaginationBox").append(pastOrdersPageNo);
      //   const docFileInput = document.getElementById(element.Document_ID);
      $(".PastOrdersPgNo").on("click", this.orderDetailsLoadOrderPage);
      //   eachDocImageValid[element.Document_ID] = false;
      //   documentIdArray.push([element.Document_ID]);
    }
  };

  orderDetailsLoadOrderPage = (e) => {
    window.scrollTo(0, 0);
    e.preventDefault();

    var pageNumber = (e.target.innerText - 1) * 10;
    if (e.currentTarget.classList[1] == "CurrentOrdersPgNo") {
      this.orderDetailsLoadCurrentOredrs(pageNumber);
    } else if (e.currentTarget.classList[1] == "PastOrdersPgNo") {
      this.orderDetailsLoadPastOredrs(pageNumber);
    }
  };

  ShowCustomerPhoneNo = (orderStatus) => {
    orderStatus = orderStatus.toUpperCase();

    if (
      orderStatus == "ENQUIRY ACCEPTED" ||
      orderStatus == "ORDER DISPATCHED" ||
      orderStatus == "ORDER READY" ||
      orderStatus == "ORDER DELIVERED"
    ) {
      return true;
    } else {
      return false;
    }
  };

  ShowBottomActionButtonsFlag = (orderStatus) => {
    orderStatus = orderStatus.toUpperCase();

    if (
      orderStatus == "ENQUIRY REJECTED" ||
      orderStatus == "CART" ||
      orderStatus == "CART DELETED" ||
      orderStatus == "ORDER CANCELLED"
    ) {
      return false;
    } else if (orderStatus == "ORDER DELIVERED") {
      return "delivered";
    } else {
      return true;
    }
  };

  sendEmailReceipt = () => {
    // html not used
    var BodyHtml = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
        <html>
          <head>
            <!-- Compiled with Bootstrap Email version: 1.3.1 -->
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
            <meta http-equiv="x-ua-compatible" content="ie=edge">
            <meta name="x-apple-disable-message-reformatting">
            <meta name="viewport" content="width=device-width, initial-scale=1">
            <meta name="format-detection" content="telephone=no, date=no, address=no, email=no">
            <style type="text/css">
              body,table,td{font-family:Helvetica,Arial,sans-serif !important}.ExternalClass{width:100%}.ExternalClass,.ExternalClass p,.ExternalClass span,.ExternalClass font,.ExternalClass td,.ExternalClass div{line-height:150%}a{text-decoration:none}{color:inherit}a[x-apple-data-detectors],u+#body a,#MessageViewBody a{color:inherit;text-decoration:none;font-size:inherit;font-family:inherit;font-weight:inherit;line-height:inherit}img{-ms-interpolation-mode:bicubic}table:not([class^=s-]){font-family:Helvetica,Arial,sans-serif;mso-table-lspace:0pt;mso-table-rspace:0pt;border-spacing:0px;border-collapse:collapse}table:not([class^=s-]) td{border-spacing:0px;border-collapse:collapse}@media screen and (max-width: 600px){.w-lg-48,.w-lg-48>tbody>tr>td{width:auto !important}.w-full,.w-full>tbody>tr>td{width:100% !important}.w-16,.w-16>tbody>tr>td{width:64px !important}.p-lg-10:not(table),.p-lg-10:not(.btn)>tbody>tr>td,.p-lg-10.btn td a{padding:0 !important}.p-2:not(table),.p-2:not(.btn)>tbody>tr>td,.p-2.btn td a{padding:8px !important}.pr-4:not(table),.pr-4:not(.btn)>tbody>tr>td,.pr-4.btn td a,.px-4:not(table),.px-4:not(.btn)>tbody>tr>td,.px-4.btn td a{padding-right:16px !important}.pl-4:not(table),.pl-4:not(.btn)>tbody>tr>td,.pl-4.btn td a,.px-4:not(table),.px-4:not(.btn)>tbody>tr>td,.px-4.btn td a{padding-left:16px !important}.pr-6:not(table),.pr-6:not(.btn)>tbody>tr>td,.pr-6.btn td a,.px-6:not(table),.px-6:not(.btn)>tbody>tr>td,.px-6.btn td a{padding-right:24px !important}.pl-6:not(table),.pl-6:not(.btn)>tbody>tr>td,.pl-6.btn td a,.px-6:not(table),.px-6:not(.btn)>tbody>tr>td,.px-6.btn td a{padding-left:24px !important}.pt-8:not(table),.pt-8:not(.btn)>tbody>tr>td,.pt-8.btn td a,.py-8:not(table),.py-8:not(.btn)>tbody>tr>td,.py-8.btn td a{padding-top:32px !important}.pb-8:not(table),.pb-8:not(.btn)>tbody>tr>td,.pb-8.btn td a,.py-8:not(table),.py-8:not(.btn)>tbody>tr>td,.py-8.btn td a{padding-bottom:32px !important}[class*=s-lg-]>tbody>tr>td{font-size:0 !important;line-height:0 !important;height:0 !important}.s-4>tbody>tr>td{font-size:16px !important;line-height:16px !important;height:16px !important}.s-6>tbody>tr>td{font-size:24px !important;line-height:24px !important;height:24px !important}}
            </style>
          </head>
          <body class="bg-red-100" style="outline: 0; width: 100%; min-width: 100%; height: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-family: Helvetica, Arial, sans-serif; line-height: 24px; font-weight: normal; font-size: 16px; -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; color: #000000; margin: 0; padding: 0; border-width: 0;" bgcolor="#ff385c">
            <table class="bg-red-100 body" valign="top" role="presentation" border="0" cellpadding="0" cellspacing="0" style="outline: 0; width: 100%; min-width: 100%; height: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-family: Helvetica, Arial, sans-serif; line-height: 24px; font-weight: normal; font-size: 16px; -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; color: #000000; margin: 0; padding: 0; border-width: 0;" bgcolor="#ff385c">
              <tbody>
                <tr>
                  <td valign="top" style="line-height: 24px; font-size: 16px; margin: 0;" align="left" bgcolor="#ff385c">
                    <table class="container" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
                      <tbody>
                        <tr>
                          <td align="center" style="line-height: 24px; font-size: 16px; margin: 0; padding: 0 16px;">
                            <!--[if (gte mso 9)|(IE)]>
                              <table align="center" role="presentation">
                                <tbody>
                                  <tr>
                                    <td width="600">
                            <![endif]-->
                            <table align="center" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto;">
                              <tbody>
                                <tr>
                                  <td style="line-height: 24px; font-size: 16px; margin: 0;" align="left">
                                    <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                            &#160;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <img class="w-16" src="https://locaso-pro-data-public.s3.ap-south-1.amazonaws.com/Public_Pictures/locasoWhiteWithoutOrange.png" style="height: auto; line-height: 100%; outline: none; text-decoration: none; display: block; width: 64px; border-style: none; border-width: 0;" width="64">
                                    <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                            &#160;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <div class="space-y-4">
                                      <h1 class="text-4xl fw-800" style="padding-top: 0; padding-bottom: 0; font-weight: 800 !important; vertical-align: baseline; font-size: 36px; line-height: 43.2px; margin: 0;" align="left">ORDER STATUS</h1>
                                      <table class="s-4 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                        <tbody>
                                          <tr>
                                            <td style="line-height: 16px; font-size: 16px; width: 100%; height: 16px; margin: 0;" align="left" width="100%" height="16">
                                              &#160;
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <p class="" style="line-height: 24px; font-size: 16px; width: 100%; margin: 0;" align="left"> 2 Items, Rs.123</p>
                                      <table class="s-4 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                        <tbody>
                                          <tr>
                                            <td style="line-height: 16px; font-size: 16px; width: 100%; height: 16px; margin: 0;" align="left" width="100%" height="16">
                                              &#160;
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <table class="btn btn-red-500 rounded-full px-6 w-full w-lg-48" role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-radius: 9999px; border-collapse: separate !important; width: 192px;" width="192">
                                        <tbody>
                                          <tr>
                                            <td style="line-height: 24px; font-size: 16px; border-radius: 9999px; width: 192px; margin: 0;" align="center" bgcolor="#dc3545" width="192">
                                              
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                    <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                            &#160;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <table class="card rounded-3xl px-4 py-8 p-lg-10" role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-radius: 24px; border-collapse: separate !important; width: 100%; overflow: hidden; border: 1px solid #e2e8f0;" bgcolor="#ffffff">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 24px; font-size: 16px; width: 100%; border-radius: 24px; margin: 0; padding: 40px;" align="left" bgcolor="#ffffff">
                                            <h3 class="text-center" style="padding-top: 0; padding-bottom: 0; font-weight: 500; vertical-align: baseline; font-size: 28px; line-height: 33.6px; margin: 0;" align="center">Order Summary from locaso</h3>
                                            <p class="text-center text-muted" style="line-height: 24px; font-size: 16px; color: #718096; width: 100%; margin: 0;" align="center">Order #1234</p>
                                            <table class="p-2 w-full" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                              <tbody>
                                              
                                              </tbody>
                                            </table>
                                            <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                              <tbody>
                                                <tr>
                                                  <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                    &#160;
                                                  </td>
                                                </tr>
												
                                              </tbody>
                                            </table>
                                            <table class="hr" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
                                              <tbody>
                                                <tr>
                                                  <td style=" font-size: 15px; border-top-width: 1px; border-top-color: #e2e8f0; border-top-style: solid; height: 1px; width: 100%; margin: 0;" align="left">
                                                  <b>Vendor Name</b></td>
                                                </tr>
												<tr>
                                                  <td style=" font-size: 15px; width: 100%; margin: 0;" align="left">
                                                  Place</td>
                                                </tr>
												<tr>
                                                  <td style=" font-size: 15px; width: 100%; margin: 0;" align="left">
                                                  <b>Customer Name</b></td>
                                                </tr>
												<tr>
                                                  <td style=" font-size: 15px; width: 100%; margin: 0;" align="left">
                                                  Customer Address</td>
                                                </tr>
												<tr>
                                                  <td style=" font-size: 15px; width: 100%; margin: 0;" align="left">
                                                  Phone Number</td>
                                                </tr>
												<tr>
                                                  <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                    &#160;
                                                  </td>
                                                </tr>
												<tr>
                                                  <td style=" font-size: 15px; border-top-width: 1px; border-top-color: #e2e8f0; border-top-style: solid; height: 1px; width: 100%; margin: 0;" align="left">
                                                  Mode of Delivery: SELF PICK UP</td>
                                                </tr>
												<tr>
                                                  <td style=" font-size: 15px; width: 100%; margin: 0;" align="left">
                                                  Delivery Date and Time:</td>
                                                </tr>
												<tr>
                                                  <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                    &#160;
                                                  </td>
                                                </tr>
												<tr>
                                                  <td style=" font-size: 15px; border-top-width: 1px; border-top-color: #e2e8f0; border-top-style: solid; height: 1px; width: 100%; margin: 0;" align="left">
                                                  <b><u>Details</u><b></td>
                                                </tr>
												<tr>
                                                  <td style=" font-size: 15px; width: 100%; margin: 0;" align="left">Item 1
                                                  </td>
												  <td style=" font-size: 15px; width: 100%; margin: 0;" align="right">
                                                  &#8377;50</td>
                                                </tr>
												<tr>
                                                  <td style=" font-size: 15px; width: 100%; margin: 0;" align="left">Item 2
                                                  </td>
												  <td style=" font-size: 15px; width: 100%; margin: 0;" align="right">
                                                  &#8377;50</td>
                                                </tr>
												<tr>
                                                  <td style=" font-size: 15px; width: 100%; margin: 0;" align="left">Item Total
                                                  </td>
												  <td style=" font-size: 15px; width: 100%; margin: 0;" align="right">
                                                  &#8377;50</td>
                                                </tr>
												<tr>
                                                  <td style=" font-size: 15px; width: 100%; margin: 0;" align="left">Offers Discount
                                                  </td>
												  <td style=" font-size: 15px; width: 100%; margin: 0;" align="right">
                                                  &#8377;50</td>
                                                </tr>
												<tr>
                                                  <td style=" font-size: 15px; width: 100%; margin: 0;" align="left">Packaging Charges
                                                  </td>
												  <td style=" font-size: 15px; width: 100%; margin: 0;" align="right">
                                                  &#8377;50</td>
                                                </tr>
												<tr>
                                                  <td style=" font-size: 15px; width: 100%; margin: 0;" align="left">GST
                                                  </td>
												  <td style=" font-size: 15px; width: 100%; margin: 0;" align="right">
                                                  &#8377;50</td>
                                                </tr>
												<tr>
                                                  <td style=" font-size: 15px; width: 100%; margin: 0;" align="left">Delivery Charges
                                                  </td>
												  <td style=" font-size: 15px; width: 100%; margin: 0;" align="right">
                                                  &#8377;50</td>
                                                </tr>
												<tr>
                                                  <td style=" font-size: 15px; width: 100%; margin: 0;" align="left">Coupon Discount
                                                  </td>
												  <td style=" font-size: 15px; width: 100%; margin: 0;" align="right">
                                                  &#8377;50</td>
                                                </tr>
												<td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                    &#160;
                                                  </td>
												  <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                    &#160;
                                                  </td>
												<tr>
                                                  <td style=" font-size: 15px; border-top-width: 1px; border-top-color: #e2e8f0; border-top-style: solid; height: 1px; width: 100%; margin: 0;" align="left">
                                                  <b>Paid Via COD</b></td>
												  <td style=" font-size: 15px; width: 100%; margin: 0;" align="right">
                                                  TOTAL&#8377;50</td>
                                                </tr>
												
                                              </tbody>
                                            </table>
                                            <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                              <tbody>
                                                <tr>
                                                  <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                    &#160;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
											<table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                              <tbody>
                                                <tr>
                                                  <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                    &#160;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                            
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                            &#160;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <!--[if (gte mso 9)|(IE)]>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                            <![endif]-->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          <script data-cfasync="false" src="/cdn-cgi/scripts/5c5dd728/cloudflare-static/email-decode.min.js"></script></body>
        </html>
        `;

    // Api to send Receipt Email
    $.ajax({
      url: baseURL + "api/AmazonSesSmtp/emailVendorReceipt",
      type: "POST",
      // async: false,
      data: {
        OrderId: Ord_id,
      },
      success: (result) => {},
      error: (error) => {},
    });
    // window.open(`${baseURL}api/OrderDetailsEmail?OrderId=` + Ord_id, "_blank");
  };

  loadStatusOptions = (orderFlow) => {
    $(".changeStatusBtn").removeClass("d-none");

    //To Get Current Orders

    // MENU BASED
    let menuFlow = [
      ["ACCEPTED", "ENQUIRY ACCEPTED", "none"],
      ["REJECTED", "ENQUIRY REJECTED", "none"],
      ["READY FOR PICK UP", "ORDER READY", "none"],
      ["OUT FOR DELIVERY", "ORDER OUT FOR DELIVERY", "none"],
      ["DELIVERED", "ORDER DELIVERED", "block"],
    ];
    // DYNAMIC BASED
    let dynamicFlow = [
      ["ACCEPTED", "ENQUIRY ACCEPTED", "none"],
      ["REJECTED", "ENQUIRY REJECTED", "none"],
      ["READY FOR PICK UP", "ORDER READY", "none"],
      ["OUT FOR DELIVERY", "ORDER OUT FOR DELIVERY", "none"],
      ["DELIVERED", "ORDER DELIVERED", "block"],
    ];
    // BOOKING BASED
    let bookingFlow = [
      ["ACCEPTED", "ENQUIRY ACCEPTED", "none"],
      ["REJECTED", "ENQUIRY REJECTED", "none"],
      ["ON ROUTE", "ORDER OUT FOR DELIVERY", "none"],
      ["DELIVERED", "ORDER DELIVERED", "block"],
    ];
    // $("#oredrStatusOptionsBox").empty();
    var statusOptionsMain = ``;
    var checkedFlag;
    //if Flow is Menu
    let currentOrderFlow = menuFlow;
    //if Flow is Booking
    if (orderFlow == "Booking") {
      currentOrderFlow = bookingFlow;
    }
    //if Flow is Dynamic
    else if (orderFlow == "Dynamic") {
      currentOrderFlow = dynamicFlow;
    }

    for (let i = 0; i < currentOrderFlow.length; i++) {
      if (orderStatus.toUpperCase() == currentOrderFlow[i][1]) {
        checkedFlag = `checked`;
      } else {
        checkedFlag = ``;
      }
      statusOptionsMain = `${statusOptionsMain} <div class="form-check">
    <input class="form-check-input statusOption" type="radio" name="statusinfo" id="status${currentOrderFlow[i][0]}" onclick="document.getElementById('deliveryCodeDiv').style.display='${currentOrderFlow[i][2]}'" value="${currentOrderFlow[i][1]}" ${checkedFlag}>
    <label class="form-check-label" for="status${currentOrderFlow[i][0]}">${currentOrderFlow[i][0]}</label></div>`;
    }
    statusOptionsMain = `${statusOptionsMain} &nbsp;&nbsp;<div id="addDelivChargesDiv" class="d-none"><label for="additionalDelivChargesInput">ADDITIONAL DELIVERY CHARGES</label><input class="form-control" id="additionalDelivChargesInput" type="text" value="0"><div class='text-danger' id="addChangeErrorMsg"></div></div>`;

    statusOptionsMain = `${statusOptionsMain} &nbsp;&nbsp;<div id="deliveryCodeDiv" style="display:none;"><label for="deliveryCodeInput">DELIVERY CODE</label><input class="form-control" id="deliveryCodeInput" type="text"><div class='text-danger' id="statusChangeErrorMsg"></div></div>`;

    statusOptionsMain = `${statusOptionsMain} &nbsp;&nbsp;<div id="ComissionDiv" class='text-danger d-none' >Standard charge of ${comissionAmt} rupees will be deducted for accepting the order. Please note that the charge is for providing you lead. There is no refund if enquiry is cancelled or you reject the order.</div>`;

    statusOptionsMain = `${statusOptionsMain} <div class="d-flex justify-content-end"><a class="getPointsbtnInmodal link-primary" data-bs-dismiss="modal" aria-label="Close">Get Points</a></div>`;

    $("#oredrStatusOptionsBox").empty();
    $("#oredrStatusOptionsBox").append(statusOptionsMain);

    //To display Additional Delivery charges box at initial load
    this.statusIsChanged();

    //To go to Payments(Get points page)
    $(".getPointsbtnInmodal").on(
      "click",
      orderDetailsjs.getPointsbtnInmodalAction,
    );

    $(".statusOption").on("click", this.loadStatusMessage);
    $(".statusOption").on("click", this.statusIsChanged);
  };

  //To show and hide Additional Delivery charges box on change of status
  statusIsChanged = () => {
    const ACCEPTEDcheckbox = document.querySelector("#statusACCEPTED");
    if (ACCEPTEDcheckbox.checked) {
      //To show Comission Amt message
      $("#ComissionDiv").removeClass("d-none");
    } else {
      $("#ComissionDiv").addClass("d-none");
    }
    if (ACCEPTEDcheckbox.checked && deliveryType != "None") {
      // Line commented to Remove additional Delivery Charges Input
      // $("#addDelivChargesDiv").removeClass("d-none");
    } else {
      $("#addDelivChargesDiv").addClass("d-none");
      $("#additionalDelivChargesInput").val(null);
    }
  };

  loadStatusMessage = () => {
    let statusRadioButtons = document.getElementsByName("statusinfo");
    for (let i = 0; i < statusRadioButtons.length; i++) {
      if (statusRadioButtons[i].checked) {
        var statusOptionsMessage = ` You have successfully updated the enquiry to ${statusRadioButtons[i].value}. Thank You.`;
        $("#updatedStatusMessage").empty();
        $("#updatedStatusMessage").append(statusOptionsMessage);

        break;
      }
    }
    // $(".statusOption").on("click", this.loadStatusMessage);
  };

  InputWholeNumber = () => {
    //To remove additional Delivery Charges Input
    return true;

    // document.getElementById("additionalDelivChargesInput").value = 0;

    const ACCEPTEDcheckbox = document.querySelector("#statusACCEPTED");
    if (ACCEPTEDcheckbox.checked) {
      var additional_Delivery_Val = document.getElementById(
        "additionalDelivChargesInput",
      ).value;
      additional_Delivery_Val = parseInt(additional_Delivery_Val);

      if (Number.isInteger(additional_Delivery_Val)) {
        if (additional_Delivery_Val >= 0) {
          $("#addChangeErrorMsg").html("");

          return true;
        } else {
          $("#addChangeErrorMsg").html("Please enter the correct amount");
          console.error(additional_Delivery_Val + " is a negative number.");

          return false;
        }
      } else {
        $("#addChangeErrorMsg").html("Please enter the correct amount");
        console.error(additional_Delivery_Val + " is not a whole number.");
      }
      return false;
      // $("#additionalDelivChargesInput").val();
      // $("#addDelivChargesDiv").removeClass("d-none");
    }
    return true;
  };

  submitStatusAction = () => {
    var selectedValue = "Not Selected";
    //
    //
    var radioButtons = document.getElementsByClassName("statusOption");
    for (var i = 0; i < radioButtons.length; i++) {
      if (radioButtons[i].checked) {
        selectedValue = radioButtons[i].value;

        break;
      }
    }

    if (this.InputWholeNumber()) {
      /////To remove additional Delivery Charges Input

      var AdditionalDeliveryCharges = document.getElementById(
        "additionalDelivChargesInput",
      ).value;
      if (AdditionalDeliveryCharges <= 0 || isNaN(AdditionalDeliveryCharges)) {
        AdditionalDeliveryCharges = 0;
      }
      /////
      // return;
      $.ajax({
        type: "POST",
        url: baseURL + "api/vendor/updateOrderStatus",
        data: {
          Order_ID: Ord_id,
          Status: selectedValue,
          Delivery_OTP_Code: document.getElementById("deliveryCodeInput").value,
          Additional_Delivery_Charges: document.getElementById(
            "additionalDelivChargesInput",
          ).value,
        },
        // url: baseURL + "api/vendor/GetOrderStatuses",
        // url: baseURL + "api/vendor/GetVendorCategories",
        headers: { Authorization: X_API_KEY },
        // success: function (res) {
        //
        //   error:
        // },
      })
        .done(function (res) {
          var newOdrStus = (res && res["Msg"] ? res["Msg"] : "").toUpperCase();

          //Execute when Order is Accepted
          if (
            newOdrStus == "ENQUIRY ACCEPTED" ||
            newOdrStus == "ORDER READY" ||
            newOdrStus == "ORDER OUT FOR DELIVERY" ||
            newOdrStus == "ORDER DELIVERED" ||
            newOdrStus == "ENQUIRY REJECTED"
          ) {
            //Calling api to send message to Customer When Enquiry Accepted
            $.ajax({
              url: baseURL + "api/AmazonSesSmtp/sendCustomerOrderAcceptedEmail",
              type: "POST",
              data: {
                Order_ID: Ord_id,
              },
              success: (result) => {
                $(".emailsSendStatusMsg").empty();
                const infoMsg =
                  result && result["Details"] ? result["Details"] : "";
                if (infoMsg) {
                  $(".emailsSendStatusMsg").append(`${infoMsg}`);
                }
              },
              error: (error) => {},
            });
          }
        })
        .fail(function (res) {
          if (res["status"] === 404) {
            console.error("Page not found");
          } else {
            console.error("Error: " + res["responseJSON"]["Msg"]);
          }
          // getElementById("statusChangeErrorMsg").innerHTML =
          //   res["responseJSON"]["Msg"];

          var statusOptionsMessage = ` ${res["responseJSON"]["Msg"]}`;
          $("#updatedStatusMessage").empty();
          $("#updatedStatusMessage").append(statusOptionsMessage);
          if (res["responseJSON"]["code"] == "48") {
            $("#updatedStatusMessage").append(`
              <div class="d-flex justify-content-center mt-3">
              <button class="btn btn-warning getPointsbtnInmodal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">Get Points</button>
              </div>
            `);
          }
          // $(".getPointsbtnInmodal").on(
          //   "click",
          //   orderDetailsjs.getPointsbtnInmodalAction
          // );

          $(".statusMsgCloseBtn").addClass("d-none");

          // $("#updatedStatusMessage").empty();
          document.getElementById("orderStatusMsgHeading").innerHTML = "ALERT";
        });

      window.$("#changestatus").modal("hide");
      window.$("#updatedStatusModal").modal("show");
      this.getOrderDetails(Ord_id);
      this.bindEvents();

      // this.launchStatusMessageModal();
    }
  };

  launchStatusMessageModal = () => {
    // this.loadStatusMessage();
    // Get the modal and the background element
    var modal = document.getElementById("updatedStatusModal");
    var modalBackdrop = document.getElementsByClassName(
      "VendorDashboardPage",
    )[0];

    // Show the modal
    modal.style.display = "block";

    // Disable the background
    modalBackdrop.style.pointerEvents = "none";

    // Close the modal when the close button is clicked
    var closeButton = document.getElementsByClassName("statusMsgCloseBtn")[0];
    closeButton.onclick = () => {
      modal.style.display = "none";
      modalBackdrop.style.pointerEvents = "auto";
      // location.reload();
      // this.getOrderDetails();
    };
    // this.getOrderDetails();
  };

  //To Resend sms of Delivery OTP to customer
  resendDeliveryOTP = (e) => {
    e.preventDefault;

    var currentTHIS = this;

    $.ajax({
      type: "POST",
      url: baseURL + "api/Msg91/sendDeliveryCodeSMS",
      data: {
        Order_ID: e.target.value,
        customerName: e.target.name,
      },
      headers: { Authorization: X_API_KEY },
    })
      .done(function (res) {
        $("#SendDeliveryOTPModalMsg").html(
          "The delivery OTP has been successfully sent to the customer.",
        );

        window.$("#SendDeliveryOTPModal").modal("show");
        $("#SendDeliveryOTPModalCloseBtn").on(
          "click",
          currentTHIS.closeDeliveryOTPResponseModal,
        );
      })
      .fail(function (res) {
        $("#SendDeliveryOTPModalMsg").html(
          "The delivery OTP could not be sent to the customer.",
        );

        window.$("#SendDeliveryOTPModal").modal("show");
        $("#SendDeliveryOTPModalCloseBtn").on(
          "click",
          currentTHIS.closeDeliveryOTPResponseModal,
        );
      });
  };

  getPointsbtnInmodalAction = () => {
    $(".currentlyActive").addClass("d-none");
    $(".currentlyActive").removeClass("currentlyActive");
    $(".vendorPoints").addClass("currentlyActive");
    $(".vendorPoints").removeClass("d-none");
  };

  closeDeliveryOTPResponseModal = (e) => {
    window.$("#SendDeliveryOTPModal").modal("hide");
  };
}

